import { ReactNode } from 'react';
import cn from 'classnames';
import { RadioGroup, Radio } from '@ds';

type IconButtonItem<T> = {
  icon: ReactNode;
  value: T;
  name?: string;
};

type IconButtonGroupProps<T> = {
  items: IconButtonItem<T>[];
  value: T;
  onValueChange?: (value: T) => void;
  disabled?: boolean;
};

export const IconButtonGroup = <T extends string>({
  items,
  value,
  onValueChange,
  disabled,
}: IconButtonGroupProps<T>) => {
  return (
    <RadioGroup
      value={value}
      onValueChange={onValueChange as ((value: string) => void) | undefined}
      isDisabled={disabled}
      orientation="horizontal"
      classNames={{
        base: 'inline-flex bg-base-50 p-0 rounded-full items-center',
        wrapper: 'gap-0',
      }}
    >
      {items.map((item) => (
        <Radio
          key={item.value}
          value={item.value}
          classNames={{
            base: cn(
              'max-w-none m-0 p-0 size-8 rounded-full flex items-center justify-center transition-colors cursor-pointer',
              'hover:bg-base-40',
              'data-[selected=true]:bg-base-5 data-[selected=true]:text-white data-[selected=true]:hover:bg-base-5',
              'text-base-5',
            ),
            wrapper: 'hidden',
            label: 'static w-auto h-auto p-0 text-current text-lg',
            labelWrapper: 'm-0',
          }}
        >
          {item.icon}
        </Radio>
      ))}
    </RadioGroup>
  );
};
